export const SUPPORT = 'supportNetwork'
export const FAMILY = 'family'
export const PEER = 'peers'

export const USER_GROUPS = [
  "Rady Children's Rehab/Surgical",
  "Rady Children's Hematology/Oncology",
  'Other'
]
